export default "__VITE_ASSET__UE4Slbqe__"